/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import moment from 'moment/moment';
import cx from 'classnames';
import {
  fromCents, getCurrencyCode, getInvoiceAmount, getMinimumFractionDigits,
} from 'utils/helpers';

const propTypes = {
  invoice: PropTypes.object.isRequired,
  contractId: PropTypes.string.isRequired,
  showAmount: PropTypes.bool,
  showInvoiceNumber: PropTypes.bool,
  mobileWalletToken: (MOBILE_WALLET ? PropTypes.string.isRequired : PropTypes.string),
};

const defaultProps = {
  showInvoiceNumber: true,
};

const UnpaidInvoiceItemMobile = (props) => {
  const {
    invoice, contractId, showAmount, showInvoiceNumber,
  } = props;
  let deadlineTextKey = 'selfservice.invoices.item.deadline';
  if (invoice.dueDays === 0) {
    deadlineTextKey = 'selfservice.invoices.item.deadline.today';
  }
  if (invoice.dueDays < 0) {
    deadlineTextKey = 'selfservice.invoices.item.deadline.late';
  }

  const amount = fromCents(getInvoiceAmount(invoice));
  const classes = cx({
    'txt-error': invoice.dueDays < 0,
  });

  return (
    <p className={classes}>
      {!MOBILE_WALLET && <br />}
      {showInvoiceNumber
        && (
        <>
          <a
            href={MOBILE_WALLET
              ? `${API_HOST}/mw/invoices/${contractId}/${invoice.id}.pdf?token=${props.mobileWalletToken}`
              : `${API_HOST}/contracts/${contractId}/invoices/${invoice.id}/document`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="selfservice.invoices.header.invoiceNumber" />
            {' '}
            {invoice.invoiceNumber}
          </a>
          <br />
        </>
        )}
      {showAmount
        && (
        <>
          <FormattedNumber
            style="currency"
            currency={getCurrencyCode()}
            minimumFractionDigits={getMinimumFractionDigits(amount, 2)}
            value={amount}
          />
          <br />
        </>
        )}
      <span>
        <FormattedMessage id="selfservice.invoices.item.deadlineTitle" />
        &nbsp;
        {moment(invoice.dueDate).format('L')}
      </span>
      <br />
      <span className="txt-muted">
        <FormattedMessage
          id={deadlineTextKey}
          values={{ days: Math.abs(invoice.dueDays) }}
        />
      </span>
    </p>
  );
};

UnpaidInvoiceItemMobile.propTypes = propTypes;
UnpaidInvoiceItemMobile.defaultProps = defaultProps;

export default UnpaidInvoiceItemMobile;
